import React, { useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { Button } from "primereact/button";
import { api } from "../../../../services/api";

// Otimização dos estilos base
const inputBaseStyle = {
  width: "100%",
  padding: "8px", // Reduzido de 10px para 8px
  borderRadius: "4px",
  border: "1px solid #ccc",
  fontSize: "15px", // Reduzido de 16px
  outline: "none",
  boxShadow: "none",
  transition: "border-color 0.3s",
  marginBottom: "6px", // Reduzido de 10px para 6px
  height: "34px", // Altura fixa para todos os inputs
  boxSizing: "border-box",
};

const labelStyle = {
  display: "block",
  marginBottom: "3px", // Reduzido de 5px para 3px
  fontSize: "13px", // Reduzido de 14px
  color: "#333",
  fontWeight: 500,
};

const AddCardPage = ({ username, token, onSuccess, onCancel, onIncompletePersonalInfo }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    holderName: "",
    number: "",
    expiryMonth: "",
    expiryYear: "",
    ccv: "",
    cpfCnpj: "",
  });
  const [error, setError] = useState("");

  // Função para formatar o número do cartão com espaços
  const formatCardNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    const parts = [];
    for (let i = 0; i < digits.length; i += 4) {
      parts.push(digits.slice(i, i + 4));
    }
    return parts.join(" ");
  };

  // Funções do SDK PicPay encapsuladas em Promises
  const getPicpayCardBrand = (bin) => {
    return new Promise((resolve, reject) => {
      if (!window.CheckoutTransparent) return reject("PicPay SDK não carregado");
      window.CheckoutTransparent.getCardBrand({
        bin: String(bin).substring(0, 6),
        success: (body) => resolve(body.brand),
        error: (body) => reject(body.errors)
      });
    });
  };

  const generatePicpayCardToken = (formValues, brand) => {
    return new Promise((resolve, reject) => {
      if (!window.CheckoutTransparent) return reject("PicPay SDK não carregado");
      const card = {
        brand: brand,
        number: formValues.number.replace(/\D/g, ''),
        holderName: formValues.holderName,
        holderDocument: formValues.cpfCnpj || "00000000000",
        expirationMonth: formValues.expiryMonth,
        expirationYear: "20" + formValues.expiryYear.slice(-2), // assume ano com 2 dígitos, converte para 4
        cvv: formValues.ccv
      };

      window.CheckoutTransparent.createTemporaryCard({
        card,
        success: (body) => resolve(body.temporaryToken),
        error: (body) => reject(body.errors)
      });
    });
  };

  // Passo Único: Gerar token no SDK e enviar dados do cartão para salvar
  const handleCardSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const brand = await getPicpayCardBrand(form.number.replace(/\D/g, ''));
      const temporaryToken = await generatePicpayCardToken(form, brand);
      const cleanCardNumber = form.number.replace(/\D/g, '');

      const payload = {
        token: token,
        username: username,
        cardholderName: form.holderName,
        cardNumber: cleanCardNumber,
        cvv: form.ccv,
        expirationMonth: parseInt(form.expiryMonth, 10),
        expirationYear: parseInt("20" + form.expiryYear.slice(-2), 10),
        brand: brand.toLowerCase(),
        picpayTemporaryCardToken: temporaryToken
      };

      const res = await api.post("/payment/picpay-insert-card", payload);

      if (res.data.status === "success" || res.data.success) {
        setIsLoading(false);
        onSuccess && onSuccess();
      } else if (res.data.message === "incomplete-personal-info" && onIncompletePersonalInfo) {
        // O account_info está sem nome/CPF/telefone exigidos pelo PicPay. Em vez de mostrar
        // erro, manda o usuário completar o cadastro (tela MissingFields) e volta ao fluxo.
        setIsLoading(false);
        onIncompletePersonalInfo();
      } else {
        setError(res.data.message || "Erro ao cadastrar cartão.");
        setIsLoading(false);
      }
    } catch (err) {
      console.error(err);
      // Cobre o caso do backend responder com status HTTP de erro em vez de 200 + fail body.
      if (err?.response?.data?.message === "incomplete-personal-info" && onIncompletePersonalInfo) {
        setIsLoading(false);
        onIncompletePersonalInfo();
        return;
      }
      setError("Erro ao se comunicar com a operadora ou cadastrar o cartão.");
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <div className="modal" style={{ width: "425px" }}>
        <button
          className="close"
          onClick={onCancel}
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "-10px",
            top: "-10px",
            width: "36px",
            height: "36px",
            fontSize: "24px",
            background: "#D11A2A",
            borderRadius: "18px",
            border: "1px solid #cfcece",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            lineHeight: "normal",
            padding: 0,
          }}
        >
          ×
        </button>
        <img className="logo" src={"/img/raidhut.png"} alt="raidhut-logo" />
        <h1 className="modal-title" style={{ margin: "10px 0 5px" }}>
          Cadastrar novo cartão
        </h1>
        <h3
          className="modal-subtext"
          style={{ marginBottom: 10, fontSize: "14px" }}
        >
          Digite os dados do seu cartão para cadastro seguro
        </h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "10px", // Reduzido de 20px
            color: "#666",
            fontSize: "13px", // Reduzido de 14px
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#666"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ marginRight: "8px" }}
          >
            <path d="M12 2a10 10 0 0 1 10 10c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2z"></path>
            <path d="M12 16v-4"></path>
            <path d="M12 8h.01"></path>
          </svg>
          Seus dados estão protegidos com criptografia segura
        </div>
        <form onSubmit={handleCardSubmit} style={{ width: "100%" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {/* Nome do Titular */}
            <div>
              <label style={labelStyle}>Nome do Titular</label>
              <input
                required
                placeholder="Nome do Titular"
                value={form.holderName}
                onChange={(e) =>
                  setForm({ ...form, holderName: e.target.value })
                }
                style={inputBaseStyle}
              />
            </div>

            {/* Número do Cartão */}
            <div>
              <label style={labelStyle}>Número do Cartão</label>
              <input
                required
                placeholder="9999 9999 9999 9999"
                value={formatCardNumber(form.number)}
                onChange={(e) => {
                  const digits = e.target.value.replace(/\D/g, "").slice(0, 16);
                  setForm({ ...form, number: digits });
                }}
                maxLength={19}
                style={inputBaseStyle}
              />
            </div>

            {/* Data de Expiração e CVV na mesma linha */}
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Mês (MM)</label>
                <input
                  required
                  placeholder="MM"
                  value={form.expiryMonth}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      expiryMonth: e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 2),
                    })
                  }
                  maxLength={2}
                  style={inputBaseStyle}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Ano (AA)</label>
                <input
                  required
                  placeholder="AA"
                  value={form.expiryYear}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      expiryYear: e.target.value.replace(/\D/g, "").slice(0, 2),
                    })
                  }
                  maxLength={2}
                  style={inputBaseStyle}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>CVV</label>
                <input
                  required
                  placeholder="CVV"
                  value={form.ccv}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      ccv: e.target.value.replace(/\D/g, "").slice(0, 4),
                    })
                  }
                  maxLength={4}
                  style={inputBaseStyle}
                />
              </div>
            </div>

            {/* CPF e Email na mesma linha */}
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>CPF/CNPJ</label>
                <input
                  required
                  placeholder="CPF/CNPJ"
                  value={form.cpfCnpj}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      cpfCnpj: e.target.value.replace(/\D/g, ""),
                    })
                  }
                  style={inputBaseStyle}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>E-mail</label>
                <input
                  required
                  type="email"
                  placeholder="E-mail"
                  value={form.email || ""}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      email: e.target.value,
                    })
                  }
                  style={inputBaseStyle}
                />
              </div>
            </div>
          </div>
          {error && (
            <div style={{ color: "red", marginBottom: 10 }}>{error}</div>
          )}
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "20px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              label="Cancelar"
              onClick={onCancel}
              style={{
                borderRadius: "4px",
                border: "1px solid #ccc",
                background: "#f0f0f0",
                color: "#333",
                cursor: "pointer",
                height: "2.8rem",
                display: "flex",
                alignItems: "center",
              }}
              type="button"
            />
            <button
              className="copy-button"
              type="submit"
              disabled={isLoading}
              style={{ position: "relative", width: "250px" }}
            >
              {isLoading ? (
                <>
                  <ProgressSpinner
                    style={{
                      width: "20px",
                      height: "20px",
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                    strokeWidth="8"
                    disabled={true}
                    hoverable={false}
                  />
                  Carregando...
                </>
              ) : (
                "Cadastrar"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCardPage;
